exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input {\n  font-family: \"browallia\", FontAwesome; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/crm/continue-case-select-box/continue-case-select-box.component.scss
// module id = ../../../../../src/app/crm/continue-case-select-box/continue-case-select-box.component.scss
// module chunks = main